import _uniqueId from 'lodash/uniqueId';

// leveraging the fact Objects are assigned and copied by reference
// add name suffix to differentiate fields incase there are multiple
export const suffix = btoa('suffix');
function setUniqueFieldName(form_fields) {
    form_fields.forEach((item) => {
        if (
        item?.field_type === "checkbox" ||
        item?.field_type === "textarea" ||
        item?.field_type === "dropdown" ||
        item?.field_type === "currency" ||
        item?.field_type === "number" ||
        item?.field_type === "input" ||
        item?.field_type === "radio"
        ) {
            item['unique_id'] = `${item.field_label}${_uniqueId(`--${suffix}--`)}`;
        }

        // for fields with sub fileds, i.3 contacts, address...
        if(
            item?.field_type === 'organization' ||
            item?.field_type === 'dropdown' ||
            item?.field_type === 'contact' ||
            item?.field_type === 'address'
        ){
            item?.field_items.forEach((sub_item)=>{
                if(
                    // sub_item?.field_type === 'dropdown' ||
                    sub_item?.field_type === 'input' ||
                    sub_item?.field_type === 'number'
                ) {
                    sub_item['unique_id'] = `${sub_item.field_label}${_uniqueId(`--${suffix}--`)}`;
                }
            })
        }

        // for business sector element
        if(
            item?.field_key === 'business_sector'
        ){
            item['unique_id'] = `${item.field_key}${_uniqueId(`--${suffix}--`)}`;
        }
    })

    return form_fields;
}

// remove previously appended name suffix
function removeUniqueFieldName (values) {
    if(values?.fields){
        values?.fields?.forEach((value) => {
            if(value['name']) value['name'] = (value['name'].split(`--${suffix}--`))?.[0];
            if(value['values'] && value['values']?.length > 0){
                value['values']?.forEach((value) => {
                    if(value['name']) value['name'] = (value['name'].split(`--${suffix}--`))?.[0];
                })
            }
        })
    }else if (!Array.isArray(values)) {
        Object.keys(values)?.forEach(value => {
            const key = (value.split(`--${suffix}--`))?.[0];
            if(values[key]) {
                values[key] = values[value]
            }
        })
    }

    return values
}

export {
    setUniqueFieldName,
    removeUniqueFieldName
}